import ArrowLeftIcon from '@components/atoms/icons/arrowLeft';
import ArrowRightIcon from '@components/atoms/icons/arrowRight';
import DetailArrowLeftContainer from '@components/atoms/container/detailSynopsisArrowLeftContainer';
import DetailArrowRightContainer from '@components/atoms/container/detailSynopsisArrowRightContainer';

const ARROW_HEIGHT = 40;
const ARROW_WIDTH = 24;

interface Props {
  focused: boolean;
  display: {
    left: boolean;
    right: boolean;
  };
  navigate: {
    left: () => void;
    right: () => void;
  };
}

export default function DetailArrows({ display, focused, navigate }: Props) {
  return focused ? (
    <>
      {/* Left arrow  */}
      {display.left ? (
        <DetailArrowLeftContainer
          onClick={() => {
            navigate.left();
          }}
          id={'arrowLeft'}
        >
          <ArrowLeftIcon width={ARROW_WIDTH} height={ARROW_HEIGHT} />
        </DetailArrowLeftContainer>
      ) : null}
      {/* Right arrow  */}
      {display.right ? (
        <DetailArrowRightContainer
          onClick={() => {
            navigate.right();
          }}
          id={'arrowRight'}
        >
          <ArrowRightIcon width={ARROW_WIDTH} height={ARROW_HEIGHT} />
        </DetailArrowRightContainer>
      ) : null}
    </>
  ) : null;
}
